import { fanTokenOfferingApi } from '@capsicum/features/fan-token-offering/shared';
import { useMutation } from '@tanstack/react-query';

import type { ApiErrorResponse, PatchBuyOrderUserOpHashByBuyOrderData } from '@capsicum/common';
import type { AxiosError } from 'axios';

export const UsePatchOpHashMutationKey = ['patchUserOpHash'] as const;

export const useFanTokenOfferingOpHashQuery = () =>
	useMutation<
		PatchBuyOrderUserOpHashByBuyOrderData,
		AxiosError<ApiErrorResponse>,
		{ buyOrder: string | undefined; userOpHash: string },
		unknown
	>({
		mutationFn: async ({ buyOrder, userOpHash }) =>
			(await fanTokenOfferingApi).patchBuyOrderUserOpHashByBuyOrder(buyOrder || '', { userOpHash }),
		mutationKey: UsePatchOpHashMutationKey
	});
